var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.alertDismissCount,"dismissible":"","fade":"","variant":_vm.type},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v(" "+_vm._s(_vm.text)+" ("+_vm._s(_vm.alertDismissCount)+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }